import { useMemo } from 'react';
import { Card, H2, CChart } from '../ui.jsx';
import { C, fmtK, CJSTT, mkScale } from '../lib/format.js';

export default function Forecast({ annual, L }) {
  const { isNarrow, ch } = L;

  const id = useMemo(() => Date.now(), [annual]);
  const cfg = useMemo(() => {
    const yrs = annual.map(d => d.year);
    const mk = (k, col, data) => ({
      label: k, data, borderColor: col, backgroundColor: col + '88',
      fill: true, tension: .3, borderWidth: 1.5, pointRadius: 0,
    });
    return {
      type: 'line',
      data: {
        labels: yrs,
        datasets: [
          mk('James Pension', C.blue, annual.map(d => Math.round(d.jPen / 1000))),
          mk('Joanne Pension', C.pink, annual.map(d => Math.round(d.oPen / 1000))),
          mk('James ISA', '#38BDF8', annual.map(d => Math.round(d.jISA / 1000))),
          mk('Joanne ISA', '#FDA4AF', annual.map(d => Math.round(d.oISA / 1000))),
          mk('Bonds', C.gold, annual.map(d => Math.round((d.jPB + d.oPB) / 1000))),
          mk('Company', C.teal, annual.map(d => Math.round(d.cNet / 1000))),
        ],
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        plugins: { tooltip: { ...CJSTT }, legend: { labels: { color: C.text, boxWidth: 12, font: { size: 11 } } } },
        scales: { ...mkScale(), y: { ...mkScale().y, stacked: true } },
      },
    };
  }, [annual]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Card>
        <H2 sub="All assets in £000s · assumes contributions continue throughout">Projected Wealth Forecast</H2>
        <CChart cfg={cfg} height={ch(400)} id={id} />
      </Card>

      <Card>
        <H2>Portfolio at Key Years</H2>
        <div style={{ display: 'grid', gridTemplateColumns: isNarrow ? 'repeat(2,1fr)' : 'repeat(5,1fr)', gap: 10 }}>
          {[2026, 2028, 2031, 2033, 2035, 2037, 2039, 2041, 2045, 2050].map(yr => {
            const d = annual.find(r => r.year === yr);
            if (!d) return null;
            return (
              <div key={yr} style={{ background: C.surf, borderRadius: 10, padding: '12px 10px', textAlign: 'center', border: `1px solid ${C.bdr}` }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: C.gold, fontFamily: "'DM Mono',monospace" }}>{yr}</div>
                <div style={{ fontSize: 18, fontWeight: 700, color: C.bright, fontFamily: "'DM Mono',monospace", margin: '4px 0' }}>{fmtK(d.total)}</div>
                <div style={{ fontSize: 9, color: C.lbl }}>total</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, marginTop: 5 }}>
                  <div style={{ fontSize: 9, color: C.blue }}>JP {fmtK(d.jPen)}</div>
                  <div style={{ fontSize: 9, color: C.pink }}>OP {fmtK(d.oPen)}</div>
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
